<template>
  <Card class="flex flex-col justify-between">
    <div class="text-xs uppercase tracking-wide text-gray-500 dark:text-gray-400">{{ label }}</div>
    <div class="mt-1 text-2xl font-bold text-gray-900 dark:text-white font-mono">{{ value }}</div>
    <div v-if="sub" class="mt-1 text-xs text-gray-500 dark:text-gray-400">{{ sub }}</div>
  </Card>
</template>

<script setup lang="ts">
  import { Card } from '@asabdev/asab-ui';

  defineProps<{
    label: string;
    value: string | number;
    sub?: string;
  }>();
</script>
